<template>
  <div>
    <highlightable-input-component
        :class="[
        {
          'text-input': !isTextHasWord() && !isTextHasChar(),
          'has-error-highlightable-input': isTextHasWord() || isTextHasChar(),
        },
        computedCustomClass,
      ]"
        :highlight-style="highlightStyle"
        :highlight-enabled="highlightEnabled"
        :highlight="highlight"
        ref="inputText"
        v-model="text"
        @input="onInput"
    />
    <div
        class="text-danger"
        :class="{ 'has-text': isTextHasWord() || isTextHasChar() }"
    >
      <template v-if="isTextHasWord()">
        This word cannot be used in the comment
      </template>
      <template v-else-if="isTextHasChar()">
        This character cannot be used in the comment
      </template>
    </div>
    <div v-if="isShowListMentionedUsers">
      <div v-if="showListMentionedUsers" class="list-mentioned-users">
        <ul>
          <li v-for="user in mentionUsers" @click="selectUser(user)">
            {{ user.name }}
          </li>
        </ul>
        <!--          <input type="text">-->
      </div>
      <button
          @click="showListMentionedUsers = !showListMentionedUsers"
          class="text-list-mentioned-users"
      >
        <i class="bx bx-message-square-add"></i>
      </button>
    </div>
    <button class="text-send">
      <i
          v-if="isShowSendIcon"
          @click="onInputEnter"
          style="transform: translateY(11px)"
          class="bx bxs-right-arrow-square"
      ></i>
    </button>
  </div>
</template>

<script>
import HighlightableInputComponent from 'vue-highlightable-input';
import SearchFilter from '@/components/utility/search-filter/search-filter.vue'

export default {
  name: 'HighlightableInput',
  components: {
    SearchFilter,
    HighlightableInputComponent,
  },
  props: {
    isForChat: {
      type: Boolean,
      default: false,
    },
    isShowSendIcon: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    limit: {
      type: Number,
      default: -1,
    },
    customClass: {
      type: String,
      default: '',
    },
    isShowListMentionedUsers: {
      type: Boolean,
      default: false,
    },
    mentionUsers: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      text: '',
      highlight: [
        'whatever',
        '$',
        'dollar',
        'dollars',
        '00.00',
        '0.00',
        'price match',
        'price beat',
        'percentage',
        'discount',
        '%',
        'competition',
        'reduction',
        'pricing',
        'rebate',
        {
          text: /(?<=\B@)[A-Za-z0-9_\-\u0020\u00A0]+\u2007/g,
          // text: /\B@[A-Za-z0-9_]+/g,
          style:
              'background-color: transparent; color: #29babf; font-weight: bold;',
        },
        {
          text: /@/g,
          style: 'display: none;',
        },
      ],
      highlightStyle:
          'background-color: #FFD5D0; border-bottom: 1px solid #FF0000;',
      highlightEnabled: true,
      showListMentionedUsers: false,
      usersIds: [],
    };
  },
  mounted() {
    this.text = this.value;

    if (this.limit !== -1) {
      this.$refs.inputText.saveSelection = function (containerEl) {
        var start;
        if (window.getSelection && document.createRange) {
          var selection = window.getSelection();
          if (!selection || selection.rangeCount == 0) return;
          var range = selection.getRangeAt(0);
          var preSelectionRange = range.cloneRange();
          preSelectionRange.selectNodeContents(containerEl);
          preSelectionRange.setEnd(range.startContainer, range.startOffset);
          start = preSelectionRange.toString().length;

          return {
            start: start > 50 ? 50 : start,
            end:
                start + range.toString().length > 50
                    ? 50
                    : start + range.toString().length,
          };
        } else if (document.selection) {
          var selectedTextRange = document.selection.createRange();
          var preSelectionTextRange = document.body.createTextRange();
          preSelectionTextRange.moveToElementText(containerEl);
          preSelectionTextRange.setEndPoint('EndToStart', selectedTextRange);
          start = preSelectionTextRange.text.length;

          return {
            start: start > 50 ? 50 : start,
            end:
                start + selectedTextRange.text.length > 50
                    ? 50
                    : start + selectedTextRange.text.length,
          };
        }
      };
    }

    if (this.$refs.inputText?.$el) {
      this.$refs.inputText.$el.addEventListener('keydown', (e) => {
        if (e.keyCode === 13) {
          e.preventDefault();
          this.onInputEnter(e);
        }
      });
    }
  },
  computed: {
    computedCustomClass() {
      if (this.customClass) {
        return this.customClass;
      }
      return '';
    },
    originaText(){
     return this.getTextWithMarks(this.text, this.usersIds)
    }
  },
  methods: {
    replaceUserSpans(text) {
      //checks the text for presence <mark class="mention" data-uid="..." (or) data-gid="...">...</mark>
      const newText = text.replace(
          /<mark\b([^>]*)\bclass=(["'])mention\2([^>]*)>(.*?)<\/mark>/gi,
          (fullMatch, beforeClass, _q, afterClass, username) => {
            const attrs = `${beforeClass} ${afterClass}`;

            const uidMatch = attrs.match(/\bdata-uid=(["'])(.*?)\1/i);
            const gidMatch = attrs.match(/\bdata-gid=(["'])(.*?)\1/i);

            const uid = uidMatch ? uidMatch[2] : null;
            const gid = gidMatch ? gidMatch[2] : null;

            this.addUserId(username, uid, gid);

            return `@${username}\u2007`;
          },
      );
      return newText;
    },
    addUserId(name, uid, gid) {
      const existingUser = this.usersIds.find(
          (user) => user.name === name,
      );
      if (!existingUser) {
        this.usersIds.push({ name, uid, gid });
      }
      // console.log('addUserId',this.usersIds)
    },

    selectUser(user) {
      this.showListMentionedUsers = false;
      this.$emit('onSelectUser', user);
    },
    onInput(e) {
      this.$emit('input', e);
    },
    onInputEnter(e) {
      console.log('onInputEnter', this.isForChat);
      if (this.isForChat){
        this.$emit('onSubmitMessage',  this.getTextWithMarks(this.text, this.usersIds));
        this.usersIds = []
      }else {
        this.$emit('onEnter', e);
      }
    },
    focus() {
      if (this.$refs.inputText?.$el) {
        this.$refs.inputText.$el.focus();
      }
    },
    getTextWithMarks(text, users) {
      return text.replace(/@([A-Za-z0-9_\-\u0020\u00A0]+)\u2007/g, (match, username) => {
        const user = users.find((user) => user.name === username);

        if (user) {
          let attrs = '';
          if (user.uid) attrs += ` data-uid="${user.uid}"`;
          if (user.gid) attrs += ` data-gid="${user.gid}"`;
          return `<mark class="mention"${attrs}>${username}</mark>`;
        }
      });
    },
    indexes(source, find) {
      if (!source) return [];
      const result = [];

      if (find && typeof find === 'object' && find.text instanceof RegExp) {
        let match;
        const re = new RegExp(find.text.source, find.text.flags);
        while ((match = re.exec(source)) !== null) {
          result.push(match.index);

          if (match.index === re.lastIndex) re.lastIndex++;
        }
        return result;
      }

      if (typeof find === 'string') {
        const s = source.toLowerCase();
        const f = find.toLowerCase();
        let i = 0;
        while (i < s.length) {
          if (s.substring(i, i + f.length) === f) {
            result.push(i);
            i++;
          } else {
            i++;
          }
        }
        return result;
      }
      return [];
    },
    findHighlights(text = '') {
      const result = {};
      _.forEach(this.highlight, (item) => {
        const positions = this.indexes(text, item);
        if (positions.length) {
          positions.forEach((pos) => {
            result[pos] = item;
          });
        }
      });
      return result;
    },
    isHighlight(condition = (hl) => hl.length > 1) {
      let highlights = this.findHighlights(this.text),
          result = false,
          lastFound = '';
      if (!_.isEmpty(highlights)) {
        let keys = _.map(Object.keys(highlights), (item) => {
          return Number(item);
        });
        lastFound = _.max(keys);
        result = condition(highlights[lastFound]);
      }
      this.$emit('onHighlight', !_.isEmpty(highlights));
      return result;
    },
    isTextHasWord() {
      return this.isHighlight();
    },
    isTextHasChar() {
      return this.isHighlight((hl) => hl.length === 1);
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.text = this.replaceUserSpans(newVal);
        this.focus();
      },
    },
    text: {
      handler: function (val) {
        if (this.limit !== -1) {
          this.$nextTick(() => {
            this.$set(this, 'text', val.substr(0, this.limit));
          });
        }

        this.$emit('input', this.getTextWithMarks(this.text, this.usersIds));
        this.$nextTick(() => {
          const el = this.$refs.inputText.$el;

          el.focus();

          const range = document.createRange();
          range.selectNodeContents(el);
          range.collapse(false);

          const sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
        });
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.text-input {
  height: 90%;
  word-break: break-all;
}

.text-danger.has-text {
  border: 1px solid #dddad6;
  margin-top: 1px;
  border-radius: 3px;
  margin-left: 35px;
}

.text-typing {
  display: flex;
  font-size: 13px;
  margin: 5px;
  color: grey;
}

.text-typing-dot {
  background-color: grey;
  border-radius: 100%;
  width: 5px;
  height: 5px;
  margin: 9px 2px 0;
  align-items: flex-end;
}

.text-typing-one-dot {
  margin-left: 3px;
  -webkit-animation: pulsing1 2s infinite;
  animation: pulsing1 2s infinite;
}

.text-typing-two-dot {
  -webkit-animation: pulsing2 2s infinite;
  animation: pulsing2 2s infinite;
  animation-delay: 0.5s;
}

.text-typing-three-dot {
  -webkit-animation: pulsing3 2s infinite;
  animation: pulsing3 2s infinite;
  animation-delay: 1s;
}

.list-mentioned-users {
  position: absolute;
  bottom: 47px;
  left: 4px;
  border: 2px solid #a5a5a5;
  border-radius: 5px;
  background-color: #fdfdfd;
  padding: 3px;
  max-height: 475px;
  overflow-x: auto;
  scrollbar-width: thin;
}

.list-mentioned-users ul {
  padding-left: 0;
  list-style: none;
}

.list-mentioned-users ul li {
  padding: 5px 7px;
  cursor: pointer;
}

.list-mentioned-users ul li:hover {
  background-color: #ceeeef;
  color: #223131;
  border-radius: 3px;
}

.list-mentioned-users input {
  height: 30px;
  font-size: 12px;
  font-weight: 600;
  padding: 5px 8px;
  border: 2px solid #a5a5a5;
  margin-left: 5px;
  margin-right: 5px;
  margin-bottom: 3px;
}

@-webkit-keyframes pulsing1 {
  0% {
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
  }
  50% {
    -webkit-transform: scale(0.7, 0.7);
    transform: scale(0.7, 0.7);
  }
  100% {
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
  }
}

@keyframes pulsing1 {
  0% {
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
  }
  50% {
    -webkit-transform: scale(0.7, 0.7);
    transform: scale(0.7, 0.7);
  }
  100% {
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
  }
}

@-webkit-keyframes pulsing2 {
  0% {
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
  }
  50% {
    -webkit-transform: scale(0.7, 0.7);
    transform: scale(0.7, 0.7);
  }
  100% {
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
  }
}

@keyframes pulsing2 {
  0% {
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
  }
  50% {
    -webkit-transform: scale(0.7, 0.7);
    transform: scale(0.7, 0.7);
  }
  100% {
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
  }
}

@-webkit-keyframes pulsing3 {
  0% {
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
  }
  50% {
    -webkit-transform: scale(0.7, 0.7);
    transform: scale(0.7, 0.7);
  }
  100% {
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
  }
}

@keyframes pulsing3 {
  0% {
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
  }
  50% {
    -webkit-transform: scale(0.7, 0.7);
    transform: scale(0.7, 0.7);
  }
  100% {
    -webkit-transform: scale(1, 1);
    transform: scale(1, 1);
  }
}
.user {
  color: red;
}
.text-send {
  position: absolute;
  right: 0;
  bottom: 15px;
  border: 0;
  background-color: rgba(255, 255, 255, 0);
}

.text-list-mentioned-users {
  position: absolute;
  left: -3px;
  bottom: 6px;
  border: 0;
  background-color: rgba(255, 255, 255, 0);
}

.bxs-right-arrow-square {
  font-size: 30px;
  color: #29babf;
}

.bx-message-square-add {
  font-size: 27px;
  color: #29babf;
}
</style>
